<script setup>
import { TagsInputInput } from 'radix-vue'
import { cn } from '@/lib/utils'

const props = defineProps({
  placeholder: { type: String, required: false },
  autoFocus: { type: Boolean, required: false },
  maxLength: { type: Number, required: false },
  asChild: { type: Boolean, required: false },
  as: { type: null, required: false },
  class: { type: null, required: false },
})
</script>

<template>
  <TagsInputInput
    v-bind="props"
    :class="cn(
      'flex-1 bg-transparent px-1 py-1 text-sm outline-none placeholder:text-muted-foreground',
      props.class
    )"
  />
</template>
